var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 3.5,
    fill: "#00FFE0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 3.5,
    stroke: "#009986"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63672 9.27273L7.36399 12L13.364 6",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedLight);
export default __webpack_public_path__ + "static/media/checkedLight.0b43354205b5f204e9aa2734e963509a.svg";
export { ForwardRef as ReactComponent };